/**
 * "The data behind this path changed" — the app-wide refresh signal.
 *
 * Write helpers fire it after a successful mutation; every mounted `useApi`
 * reloads when it hears it, so the page the user is looking at shows the row
 * they just created. (In the Next era this was `revalidatePath` marking the
 * server render cache stale; the event keeps the meaning without the server.)
 *
 * Paths are carried on the event, so a future version can reload selectively.
 * Today every hook reloads: only a handful are mounted at once, and being
 * right matters more here than being frugal.
 */

export const REVALIDATE_EVENT = "omnium:revalidate";

export type RevalidateDetail = { path: string };

/** Tell the app that whatever lives under `path` has changed. */
export function revalidatePath(path: string): void {
  // Write helpers can in principle run before the document exists (tests,
  // SSR-ish tooling). Nothing to notify in that case, and throwing would turn
  // a successful write into a failed one.
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<RevalidateDetail>(REVALIDATE_EVENT, { detail: { path } }),
  );
}
